import { render, staticRenderFns } from "./taxgift-subview.vue?vue&type=template&id=36570573&scoped=true&"
import script from "./taxgift-subview.vue?vue&type=script&lang=js&"
export * from "./taxgift-subview.vue?vue&type=script&lang=js&"
import style0 from "./taxgift-subview.vue?vue&type=style&index=0&id=36570573&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36570573",
  null
  
)

export default component.exports